module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fi-item",
    attrs: {
      "id": _vm.fibsdd.id
    }
  }, [_c('router-link', {
    staticClass: "list-item wrap",
    attrs: {
      "to": _vm.linkFi
    }
  }, [(_vm.fibsdd.affectation_user === _vm.idUser) ? _c('div', {
    staticClass: "fa-book-user"
  }, [_vm._v("  "), _c('span', {
    staticClass: "font-bold"
  }, [_vm._v("Fiche affecté")])]) : _vm._e(), _vm._v(" "), _c('strong', {
    staticClass: "numfiche"
  }, [_vm._v(_vm._s(_vm.fibsdd.numero))]), _vm._v(" "), (_vm.fibsdd.ordre_travail != null) ? _c('span', [_vm._v("- " + _vm._s(_vm.fibsdd.ordre_travail))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.detenteur) ? _c('span', {
    staticClass: "detenteur"
  }, [_vm._v("\n            " + _vm._s(_vm.detenteur.raison_sociale) + " - " + _vm._s(_vm.detenteur.adresse) + " - " + _vm._s(_vm.detenteur.code_postal) + " - " + _vm._s(_vm.detenteur.ville) + "\n        ")]) : _c('span', {
    staticClass: "detenteur"
  }, [_vm._v("\n            Chargement en cours...\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.installation) ? _c('span', {
    staticClass: "install"
  }, [_vm._v("\n            " + _vm._s(_vm.installation.nom) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fibsdd.supprimable === true),
      expression: "fibsdd.supprimable === true"
    }],
    staticClass: "btn del-fi",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        return _vm.delFi(_vm.fibsdd.id)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-delete"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-345e666b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/FibsddItem.vue
// module id = 751
// module chunks = 0